import { render, staticRenderFns } from "./GroupedTagSelector.vue?vue&type=template&id=3e5c22f4"
import script from "./GroupedTagSelector.vue?vue&type=script&lang=js"
export * from "./GroupedTagSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports